import { AddressRequest } from '@/main/models/request';
import { AddressByBodyshopResponse } from '@/main/models/response';

export enum AddressByBodyshopTypes {
  GET_ADDRESSBYBODYSHOP = '@addressByBodyshop/GET_ADDRESSBYBODYSHOP',
  SAVE_ADDRESSBYBODYSHOP = '@addressByBodyshop/SAVE_ADDRESSBYBODYSHOP',
  RESET_REDUCER_ADDRESSBYBODYSHOP = '@addressByBodyshop/RESET_REDUCER_ADDRESSBYBODYSHOP'
}

export interface AddressByBodyshopState {
  readonly addressByBodyshop: {
    data: AddressByBodyshopResponse[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetAddressByBodyshop {
  type: typeof AddressByBodyshopTypes.GET_ADDRESSBYBODYSHOP;
  payload: {
    request: AddressRequest;
  };
}

export interface SaveAddressByBodyshop {
  type: typeof AddressByBodyshopTypes.SAVE_ADDRESSBYBODYSHOP;
  payload: {
    data: AddressByBodyshopResponse[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerAddressByBodyshop {
  type: typeof AddressByBodyshopTypes.RESET_REDUCER_ADDRESSBYBODYSHOP;
}

export type AddressByBodyshopActionTypes =
  | GetAddressByBodyshop
  | SaveAddressByBodyshop
  | ResetReducerAddressByBodyshop;
